import { ReactNode } from 'react';
import logo from '../login/components/Logo.svg';
import classes from './LoginLayout.module.scss';

export default function LoginLayout({ children }: { children: ReactNode }) {
  return (
    <div className={classes.root}>
      <img alt="Logo" className={classes.logo} src={logo} />
      {children}
    </div>
  );
}
